'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Button = require('../../../../../../../components/buttons/Button');

var _Button2 = _interopRequireDefault(_Button);

var _ElementIcon = require('../../../../../../../components/elementIcon/ElementIcon');

var _ElementIcon2 = _interopRequireDefault(_ElementIcon);

var _elementActions = require('../../../../../../../element/elementActions');

var _popupActions = require('../../../../../../../components/popupPanel/popupActions');

require('./IconButton.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var updateElementsIcon = function updateElementsIcon(icon, selectedElements) {
    return function (dispatch, getState) {
        dispatch((0, _elementActions.updateSelectedElements)({ changes: { icon: icon, image: null, attachment: null } }));
    };
};

// Styles


// Actions


// Components
// Lib


var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
    return {
        selectIcon: function selectIcon(event) {
            dispatch(updateElementsIcon(ownProps.icon.toJS(), ownProps.selectedElements));
            dispatch((0, _popupActions.closePopup)());
        }
    };
};

var IconButton = function IconButton(props) {
    return _react2.default.createElement(
        _Button2.default,
        { className: (0, _classnames2.default)('IconButton', { active: props.isActive }), onClickFn: props.selectIcon },
        _react2.default.createElement(_ElementIcon2.default, { icon: props.icon })
    );
};

IconButton.propTypes = {
    icon: _propTypes2.default.object,
    selectedElements: _propTypes2.default.object,
    selectIcon: _propTypes2.default.func,
    isActive: _propTypes2.default.bool
};

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(IconButton);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/toolbar/selectionTools/iconTools/popup/tabContent/iconList/IconButton.js
// module id = 2241
// module chunks = 0